<template>
  <section class="container-onboarding-content">
    <div class="wrapper-title">
      <h3>{{ t('onboarding_attendee_count') }}</h3>
      <h4 class="medium">
        <AnimationTyping :text="t('onboarding_input_count_attendee')" />
      </h4>
    </div>

    <div class="wrapper-content-detail fadeinOnboarding">
      <label class="radio-option" v-for="(option, optionIndex) in participantOptions" :key="`option_${optionIndex}`">
        <input v-model="form.maxParticipants" type="radio" name="participants-number" :value="option" />
        <span class="radio-box radio-box-primary">
          {{ formatNumberWithComma(option) }}
        </span>
      </label>
    </div>

    <a class="link-dashboard fadeinOnboarding" @click.prevent="emit('moveDashboard')">
      {{ t('skip') }}
    </a>
  </section>
</template>

<script setup lang="ts">
import AnimationTyping from '@/components/animations/AnimationTyping.vue';
import { useSubscriptionStore } from '@/stores/subscription';
import { ISelfServiceOnboardingForm } from '@/types/components';
import { SERVICE_PRICE_MAP } from '@/utils/constants/chat';
import { formatNumberWithComma } from '@/utils/stringUtils.js';

const form = defineModel<ISelfServiceOnboardingForm>({
  required: true,
  default: () => ({}) as ISelfServiceOnboardingForm,
});
const emit = defineEmits(['moveDashboard']);

const { t } = useI18n();

const subscriptionStore = useSubscriptionStore();

const deniedPlanKeys = computed<string[]>(() => {
  return (
    {
      FREE: subscriptionStore.currentCredits <= 1000 ? ['SCB_P500', 'SCB_P1000', 'SCB_P2000', 'SCB_P3000'] : [],
    }[subscriptionStore.currentPlan] || []
  );
});

// 참석자 인원 옵션 목록
const participantOptions = computed<number[]>(() => {
  return Object.values(SERVICE_PRICE_MAP).reduce((acc: number[], { prefix, limitAttendee = 0 }) => {
    if (form.value.id === prefix && !deniedPlanKeys.value.includes(`${prefix}${limitAttendee}`)) {
      acc.push(limitAttendee);
    }
    return acc;
  }, []);
});

onMounted(async () => {
  await subscriptionStore.fetchSubscriptionInfo();
});
</script>

<style scoped lang="scss">
.container-onboarding-content {
  .radio-option {
    width: 100%;
    .radio-box {
      width: 100%;
    }
  }
}
</style>
